import { serverNameJava, request } from '../configs.js';

export const authenticationRequests = {
  login: (username, password) => {
    const params = { username, password };
    return request.post(`${serverNameJava}/auth/login`, params, {
      headers: {
        'Content-Type': 'application/json',
       },
     });
  }
};

export default authenticationRequests;
